import React from "react";
import "../components/styles/Hero.css";
import "../components/styles/ServicesPage.css";

import Hero from "../components/Hero";
import ServicesPage from "./ServicesPage";

export default function Home() {
  return (
    <>
      <Hero />
      <ServicesPage />
    </>
  );
}
